export default {"src":"/_next/static/image/public/images/ic_package_vertical_menu.cce73566300d3a08b48c2f9ff55e9d35.svg","height":20,"width":20};